var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Warning"},[_c('div',{staticClass:"WarningWidth"},[_c('Warning',{ref:"Warning",attrs:{"WarningData":_vm.WarningData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }